import { render, staticRenderFns } from "./CommercialBoardingHouseMultiTenant.vue?vue&type=template&id=7bc6b918&scoped=true&"
import script from "./CommercialBoardingHouseMultiTenant.vue?vue&type=script&lang=ts&"
export * from "./CommercialBoardingHouseMultiTenant.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialBoardingHouseMultiTenant.vue?vue&type=style&index=0&id=7bc6b918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc6b918",
  null
  
)

export default component.exports